
import Vue from 'vue';

export default Vue.extend({
  props: {
    /**
     * Make navigation bar is fixed to the top
     */
    fixed: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleClickLeftIcon() {
      /**
       * Handle when click left icon.
       * @event left-icon
       * @type {function}
       */
      this.$emit('left-icon');
    },
    handleClickTitle() {
      /**
       * Handle when click title.
       * @event title
       * @type {function}
       */
      this.$emit('title');
    },
    handleClickRightIcon() {
      /**
       * Handle when click right icon.
       * @event right-icon
       * @type {function}
       */
      this.$emit('right-icon');
    }
  }
});
